import  useMap from './useMap';
export default useMap
